import React from 'react';
import Card from './Card';

export default function StatCard({ title, value, icon, valueColorClass = 'text-primary' }) {
    return (
        <Card className="m-0 rounded-xl card-shadow card-hover hover-lift bg-gradient-hover">
            <div className="d-flex justify-between align-center mb-1">
                <h3 className="text-sm text-muted m-0">{title}</h3>
                {icon && <span className="text-muted">{icon}</span>}
            </div>
            <p className={`text-xl fw-bold m-0 ${valueColorClass}`}>{value}</p>
        </Card>
    );
}
